import { defineAction } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'
import inseminationReportAction from './inseminationReport.action.json' with { type: 'json' }
import { inseminationReportTypeSchema } from './inseminationReport.services'

const inseminationReportDefinition = defineAction({
  ...inseminationReportAction,

  input: z.object({
    format: reportFormatSchema,
    reportType: inseminationReportTypeSchema,
    startDate: dateOrIsoString().nullish(),
    endDate: dateOrIsoString().nullish(),
  }),
  output: z.any(),
})

export default inseminationReportDefinition
